/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendConfirmationEmailData
 */
export interface ResendConfirmationEmailData {
    /**
     * 
     * @type {string}
     * @memberof ResendConfirmationEmailData
     */
    newEmail?: string;
}

/**
 * Check if a given object implements the ResendConfirmationEmailData interface.
 */
export function instanceOfResendConfirmationEmailData(value: object): value is ResendConfirmationEmailData {
    return true;
}

export function ResendConfirmationEmailDataFromJSON(json: any): ResendConfirmationEmailData {
    return ResendConfirmationEmailDataFromJSONTyped(json, false);
}

export function ResendConfirmationEmailDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendConfirmationEmailData {
    if (json == null) {
        return json;
    }
    return {
        
        'newEmail': json['newEmail'] == null ? undefined : json['newEmail'],
    };
}

  export function ResendConfirmationEmailDataToJSON(json: any): ResendConfirmationEmailData {
      return ResendConfirmationEmailDataToJSONTyped(json, false);
  }

  export function ResendConfirmationEmailDataToJSONTyped(value?: ResendConfirmationEmailData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newEmail': value['newEmail'],
    };
}

